const uievents = require('../ui/events');
const LocalCollection = require('../../lib/util/local-collection');
const RemoteCollection = require('../../lib/util/remote-collection');
const { Auth, Migration, Settings } = require('../../services');
const Confirmation = require('../ui/confirmation');

module.exports = new function() {
	var _t = this;

	let activeUser = null;

	/**
	 * Maps decks to their last saved (or loaded) states using a "minimal"
	 * JSON serializaton omitting auto-generated timestamp fields.
	 * 
	 * Before we initiate a *real* save as indicated by a "change" event,
	 * we'll compare it to see if the change represents an actual diff.
	 */
	let states = new WeakMap();

	this.autoSave = function(deck) {
		states.set(deck, deck.toMinimalJSON());
		on(deck, 'change').then(_t.beginSaving);
	};

	this.beginSaving = function(deck) {
		// only start saving if there's a material change.
		if (states.get(deck) === deck.toMinimalJSON()) {
			return;
		} else {
			states.set(deck, deck.toMinimalJSON());
		}

		deck.status = 'Saving ...';
		clearInterval(deck.__saveTimer);
		deck.__saveTimer = setTimeout(function() {
			delete deck.__saveTimer;
			_t.save(deck).then(function() {
				deck.status = 'Saved.';
			}).catch(function(error) {
				deck.status = 'Error: ' + error.message;
			});
		}, 2000);
	};

	var localDeckStore = new LocalCollection('decks');
	var remoteDeckStore = new RemoteCollection('decks');

	activeStore = localDeckStore;

	var methods = ['getIndex', 'getAll', 'saveAll', 'get', 'save', 'remove'];
	methods.forEach(function(m) {
		_t[m] = async (...args) => {
			try {
				await Auth.currentAuthenticatedUser();

				// hack: give control back to auth event handling to ensure
				// `activeStore` is correctly set. :shrug:
				await Promise.resolve();
			} finally {
				return activeStore[m](...args);
			}
		};
	});

	const importOldDecks = async () => {
		const settings = await Settings.get();
		if (settings.migrated === true) return;

		const aws_sub = user.attributes.sub;
		const legacyDecks = await Migration.getIndex(aws_sub);
		if (legacyDecks.length > 0) {
			const spinner = new Spinner({
				message: "Legacy database decks found. Upgrading ..."
			});
			spinner.open();
			const promises = [];
			for (const deck of legacyDecks) {
				promises.push(_t.save(await deck.get()));
			}
			await Promise.allSettled(promises);
			await Settings.set({...settings, migrated: true});
			spinner.close();
		}
	};

	const importLocalDecks = async (localDecks) => {
		const jobs = [];
		for (const deck of localDecks) {
			jobs.push(_t.save(deck));
			jobs.push(localDeckStore.remove(deck.$id));
		}
		return Promise.allSettled(jobs);
	};

	/**
	 * After looking for local decks to migrate, prompts the user
	 * to migrate if local decks are found.
	 */
	const lookForLocalDecksToMigrate = async () => {
		const localDecks = await localDeckStore.getAll();
		if (localDecks.length > 0) {
			const prompt = new Confirmation({
				prompt: "You have decks saved on this device." +
					"<br /><br />Would you like to move them to your account?",
			});
			on(prompt, 'yes').then(async () => {
				const spinner = new Spinner({
					message: "Working on it!"
				});
				spinner.open();
				await importLocalDecks(localDecks);
				spinner.close();
				on(_t, 'change').fire();
			});
		}
	};

	var onUserChange = on(uievents, 'identityChange');
	onUserChange.then(async function(user) {
		await remoteDeckStore.clearCache();
		activeUser = user.username || null;
		if (user.username) {
			activeStore = remoteDeckStore;
			await importOldDecks();
			lookForLocalDecksToMigrate();
		} else {
			activeStore = localDeckStore;
		}
		on(_t, 'change').fire();
	});
	
};
